import { render, staticRenderFns } from "./ServiceAgreementEn.vue?vue&type=template&id=550bd706&scoped=true&"
import script from "./ServiceAgreementEn.vue?vue&type=script&lang=js&"
export * from "./ServiceAgreementEn.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAgreementEn.vue?vue&type=style&index=0&id=550bd706&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550bd706",
  null
  
)

export default component.exports